import { NgModule, Component } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { InsertBranchComponent } from "./Branch/insert-branch/insert-branch.component";
import { ViewBranchComponent } from "./Branch/view-branch/view-branch.component";
import { InsertCityComponent } from "./city/insert-city/insert-city.component";
import { ViewCityComponent } from "./city/view-city/view-city.component";
import { InsertCountryComponent } from "./country/insert-country/insert-country.component";
import { ViewCountryComponent } from "./country/view-country/view-country.component";
import { InsertDonationCallRequestComponent } from "./Donation-call-request/insert-donation-call-request/insert-donation-call-request.component";
import { ViewDonationCallRequestComponent } from "./Donation-call-request/view-donation-call-request/view-donation-call-request.component";
import { InsertDonationCategoryComponent } from "./Donation-category/insert-donation-category/insert-donation-category.component";
import { ViewDonationCategoryComponent } from "./Donation-category/view-donation-category/view-donation-category.component";
import { InsertDonationMainTypeComponent } from "./Donation-main-type/insert-donation-main-type/insert-donation-main-type.component";
import { ViewDonationMainTypeComponent } from "./Donation-main-type/view-donation-main-type/view-donation-main-type.component";
import { InsertDonationTypeComponent } from "./Donation-type/insert-donation-type/insert-donation-type.component";
import { DonationTypeComponent } from "./Donation-type/view-donation-type/donation-type.component";
import { InsertEventComponent } from "./Event/insert-event/insert-event.component";
import { ViewEventComponent } from "./Event/view-event/view-event.component";
import { InsertGovernorateComponent } from "./Governrate/insert-governorate/insert-governorate.component";
import { ViewGovernorateComponent } from "./Governrate/view-governorate/view-governorate.component";
import { InquiryComponent } from "./inquiry/inquiry.component";
import { CoursesRequestListComponent } from "./join-request/courses-request-list/courses-request-list.component";
import { EmploymentRequestListComponent } from "./join-request/employment-request-list/employment-request-list.component";
import { InsertJoinRequestComponent } from "./join-request/insert-join-request/insert-join-request.component";
import { ViewJoinRequestComponent } from "./join-request/view-join-request/view-join-request.component";
import { VolunteeringRequestListComponent } from "./join-request/volunteering-request-list/volunteering-request-list.component";
import { InsertJoinTypeComponent } from "./join-type/insert-join-type/insert-join-type.component";
import { ViewJoinTypeComponent } from "./join-type/view-join-type/view-join-type.component";
import { InsertKeywordsComponent } from "./keywords/insert-keywords/insert-keywords.component";
import { ViewKeywordsComponent } from "./keywords/view-keywords/view-keywords.component";
import { InsertNewsComponent } from "./News/insert-news/insert-news.component";
import { ViewNewsComponent } from "./News/view-news/view-news.component";
import { NgorganizationsDetailsComponent } from "./ngorganizations-details/ngorganizations-details/ngorganizations-details.component";
import { NGOrganizationsComponent } from "./ngorganizations/ngorganizations.component";
import { InsertOurPartnersComponent } from "./OurPartners/insert-our-partners/insert-our-partners.component";
import { ListOurPartnersComponent } from "./OurPartners/list-our-partners/list-our-partners.component";
import { PartnerRequestComponent } from "./partner-request/partner-request.component";
import { InsertPhotoAlbumComponent } from "./photo-album/insert-photo-album/insert-photo-album.component";
import { ViewPhotoAlbumComponent } from "./photo-album/view-photo-album/view-photo-album.component";
import { InsertPhotoComponent } from "./photo/insert-photo/insert-photo.component";
import { ViewPhotoComponent } from "./photo/view-photo/view-photo.component";

import { ViewProductComponent } from './product/view-product/view-product.component';
import { InsertProjectAccomplishmentComponent } from "./Projects/project-accomplishment/insert-project-accomplishment/insert-project-accomplishment.component";
import { ListProjectAccomplishmentComponent } from "./Projects/project-accomplishment/list-project-accomplishment/list-project-accomplishment.component";
import { InsertProjectComponent } from "./Projects/Project/insert-project/insert-project.component";
import { ListProjectsComponent } from "./Projects/Project/list-projects/list-projects.component";
import { JobRequestReportComponent } from "./Report/job-request-report/job-request-report.component";
import { NationalOrganizationReportComponent } from "./Report/national-organization-report/national-organization-report.component";
import { PartnerRequestReportComponent } from "./Report/partner-request-report/partner-request-report.component";
import { TrainingCoursesReportComponent } from "./Report/training-courses-report/training-courses-report.component";
import { VoluntaryRequestReportComponent } from "./Report/voluntary-request-report/voluntary-request-report.component";
import { InsertSectorLocationComponent } from "./sector-location/insert-sector-location/insert-sector-location.component";
import { ViewSectorLocationComponent } from "./sector-location/view-sector-location/view-sector-location.component";
import { InsertSectorTypeComponent } from "./sector-type/insert-sector-type/insert-sector-type.component";
import { ViewSectorTypeComponent } from "./sector-type/view-sector-type/view-sector-type.component";
import { InsertSectorComponent } from "./sector/insert-sector/insert-sector.component";
import { ViewSectorComponent } from "./sector/view-sector/view-sector.component";
import { SupplierDetailsComponent } from "./supplier-details/supplier-details.component";
import { SuppliersComponent } from "./suppliers/suppliers.component";
import { ChangePasswordComponent } from "./User/change-password/change-password.component";
import { InsertUserComponent } from "./User/insert-user/insert-user.component";
import { ViewUserComponent } from "./User/view-user/view-user.component";
import { InsertVideoAlbumComponent } from "./video-album/insert-video-album/insert-video-album.component";
import { ViewVideoAlbumComponent } from "./video-album/view-video-album/view-video-album.component";
import { InsertVideoComponent } from "./video/insert-video/insert-video.component";
import { ViewVideoComponent } from "./video/view-video/view-video.component";
import { ReportsServiceComponent } from "./Report/reports-service/reports-service.component";
import { InsertJobComponent } from "./Job/insert-job/insert-job.component";
import { ListJobComponent } from "./Job/list-job/list-job.component";
import { InsertCampaignComponent } from "./Campaign/insert-campaign/insert-campaign.component";
import { ListCampaignComponent } from "./Campaign/list-campaign/list-campaign.component";
import { OnlineDonationsStatsComponent } from "./Stats/Online-Donations-Stats/Online-Donations-Stats.component";
import { DonationsReportComponent } from "./Report/donations-reports/donations-reports.component";
import { GoldPriceComponent } from "./GoldPrice/GoldPrice/GoldPrice.component";
import { AddOrUpdateGoldPriceComponent } from "./GoldPrice/AddOrUpdateGoldPrice/AddOrUpdateGoldPrice.component";
import { CreateOrUpdateHomeImageComponent } from "./HomeImage/create-or-update-home-image/create-or-update-home-image.component";

import { DonationWayFileComponent } from "./DonationWayFile/DonationWayFile/DonationWayFile.component";




const routes: Routes = [
    {
        path: "",
        children: [
            {
                path: "InsertBranch",
                component: InsertBranchComponent,
            },
            {
                path: "ViewBranch",
                component: ViewBranchComponent,
            },
            {
                path: "InsertCity",
                component: InsertCityComponent,
            },
            {
                path: "ViewCity",
                component: ViewCityComponent,
            },
            {
                path: "InsertCountry",
                component: InsertCountryComponent,
            },
            {
                path: "ViewCountry",
                component: ViewCountryComponent,
            },
           
            {
                path: "InsertDonationCallRequest",
                component: InsertDonationCallRequestComponent,
            },
            {
                path: "ViewDonationCallRequest",
                component: ViewDonationCallRequestComponent,
            },
           
            // ====================================================
            {
                path: "InsertDonationCategory",
                component: InsertDonationCategoryComponent,
            },
            {
                path: "ViewDonationCategory",
                component: ViewDonationCategoryComponent,
            },
            {
                path: "InsertDonationmainType",
                component: InsertDonationMainTypeComponent,
            },
            {
                path: "ViewDonationmainType",
                component: ViewDonationMainTypeComponent,
            },
            {
                path: "InsertDonationType",
                component: InsertDonationTypeComponent,
            },
            {
                path: "ViewDonationType",
                component: DonationTypeComponent,
            },
            {
                path: "InsertEvent",
                component: InsertEventComponent,
            },
            {
                path: "ViewEvent",
                component: ViewEventComponent,
            },
            {
                path: "InsertGovernorate",
                component: InsertGovernorateComponent,
            },
            {
                path: "ViewGovernorate",
                component: ViewGovernorateComponent,
            },
            {
                path: "InsertJoinRequest",
                component: InsertJoinRequestComponent,
            },
            {
                path: "ViewJoinRequest",
                component: ViewJoinRequestComponent,
            },
            {
                path: "ViewEmploymentRequest",
                component: EmploymentRequestListComponent,
            },
            {
                path: "ViewCoursesRequest",
                component: CoursesRequestListComponent,
            },
            {
                path: "ViewVolunteeringRequest",
                component: VolunteeringRequestListComponent,
            },
            {
                path: "InsertJoinType",
                component: InsertJoinTypeComponent,
            },
            {
                path: "ViewJoinType",
                component: ViewJoinTypeComponent,
            },
            {
                path: "InsertNews",
                component: InsertNewsComponent,
            },
            {
                path: "update-news/:id",
                component: InsertNewsComponent,
            },
            {
                path: "ViewNews",
                component: ViewNewsComponent,
            },
            {
                path: "InsertPhoto",
                component: InsertPhotoComponent,
            },
            {
                path: "ViewPhoto",
                component: ViewPhotoComponent,
            },
            {
                path: "InsertPhotoAlbum",
                component: InsertPhotoAlbumComponent,
            },
            {
                path: "ViewPhotoAlbum",
                component: ViewPhotoAlbumComponent,
            },
            {
                path: "InsertSector",
                component: InsertSectorComponent,
            },
            {
                path: "ViewSector",
                component: ViewSectorComponent,
            },
            {
                path: "InsertSectorLocation",
                component: InsertSectorLocationComponent,
            },
            {
                path: "ViewSectorLocation",
                component: ViewSectorLocationComponent,
            },
            {
                path: "InsertSectorType",
                component: InsertSectorTypeComponent,
            },
            {
                path: "ViewSectorType",
                component: ViewSectorTypeComponent,
            },
            {
                path: "InsertUser",
                component: InsertUserComponent,
            },
            {
                path: "ViewUser",
                component: ViewUserComponent,
            },
            {
                path: "InsertVideo",
                component: InsertVideoComponent,
            },
            {
                path: "ViewVideo",
                component: ViewVideoComponent,
            },
            {
                path: "InsertVideoAlbum",
                component: InsertVideoAlbumComponent,
            },
            {
                path: "ViewVideoAlbum",
                component: ViewVideoAlbumComponent,
            },
            {
                path: "Changepassword",
                component: ChangePasswordComponent,
            },
            {
                path: "InsertKeywords",
                component: InsertKeywordsComponent,
            },
            {
                path: "ViewKeywords",
                component: ViewKeywordsComponent,
            },
            {
                path: "OurPartners",
                component: ListOurPartnersComponent,
            },
            {
                path: "insert-partner",
                component: InsertOurPartnersComponent,
            },
            {
                path: "update-partner/:id",
                component: InsertOurPartnersComponent,
            },
            {
                path: "ViewProjects",
                component: ListProjectsComponent,
            },
            {
                path: "insert-project",
                component: InsertProjectComponent,
            },
            {
                path: "update-project/:id",
                component: InsertProjectComponent,
            },
            {
                path: "ViewProjectCompletion/:id",
                component: ListProjectAccomplishmentComponent,
            },
            {
                path: "insert-projectcompletion/:id",
                component: InsertProjectAccomplishmentComponent,
            },
            {
                path: "update-projectcompletion/:id/:projectcompletionid",
                component: InsertProjectAccomplishmentComponent,
            },
            {
                path: "ViewSuppliers",
                component: SuppliersComponent,
            },
            {
                path: "ViewPartnerRequest",
                component: PartnerRequestComponent,
            },
            {
                path: "ViewNGOrganizations",
                component: NGOrganizationsComponent,
            },
            {
                path: "ViewInquiry",
                component: InquiryComponent,
            },
            {
                path: "SupplierDetails/:id",
                component: SupplierDetailsComponent,
            },
            {
                path: "NGOrganizationsDetails/:id",
                component: NgorganizationsDetailsComponent,
            },
            {
                path: "reports-service",
                component: ReportsServiceComponent,
            },
            {
                path: "VoluntaryRequestReport",
                component: VoluntaryRequestReportComponent,
            },
            {
                path: "TrainingCoursesReport",
                component: TrainingCoursesReportComponent,
            },
            {
                path: "NationalOrganizationReport",
                component: NationalOrganizationReportComponent,
            },
            {
                path: "PartnerRequestReport",
                component: PartnerRequestReportComponent,
            },
            {
                path: "JobRequestReport",
                component: JobRequestReportComponent,
            },
            {
                path: "DonationsReport",
                component: DonationsReportComponent,
            },
            
            
            // will add job curd    
            {
                path: "insert-Job",
                component: InsertJobComponent,
            },
            {
                path: "update-Job/:id",
                component: InsertJobComponent,
            },
            {
                path: "List-Job",
                component: ListJobComponent,
            },
            
            // will add Campaign curd    
            {
                path: "insert-Campaign",
                component: InsertCampaignComponent,
            },
            {
                path: "update-Campaign/:id",
                component: InsertCampaignComponent,
            },
            {
                path: "List-Campaign",
                component: ListCampaignComponent,
            },
            {
                path: "Online-Donations-Stats",
                component: OnlineDonationsStatsComponent,
            },

            {
                path: "gold-price",
                component: GoldPriceComponent,
            },
            {
                path: "update-gold-price",
                component: AddOrUpdateGoldPriceComponent,
            },
            {
                path: "update-web-image",
                component: CreateOrUpdateHomeImageComponent,
            },
            {
                path: "donation-way-file",
                component: DonationWayFileComponent,
            },
            
],
    },
];

@NgModule({
    declarations: [],
    imports: [RouterModule.forChild(routes)],
})
export class AdminRoutingModule { }
